import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesGastos() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Catalogos", items: [
      { label: "Categorias", icon: "far fa-list-alt", color: "#3b82f6", href: "/Categorias", desc: "Categorias de gasto", enabled: !!user.menu_gastos },
      { label: "SubCategorias", icon: "fas fa-list-ol", color: "#06b6d4", href: "/SubCategorias", desc: "Subcategorias", enabled: !!user.menu_gastos },
      { label: "Solicitantes", icon: "fas fa-user", color: "#6366f1", href: "/Solicitantes", desc: "Catalogo solicitantes", enabled: !!user.menu_gastos },
    ]},
    { section: "Gastos", items: [
      { label: "Gastos", icon: "fas fa-receipt", color: "#f59e0b", href: "/Gastos", desc: "Registro de gastos", enabled: !!user.menu_gastos },
      { label: "Ordenes Gastos", icon: "fas fa-receipt", color: "#10b981", href: "/OrdenesGastos", desc: "Ordenes de gasto", enabled: !!user.menu_gastos },
    ]},
  ];
  return (
    <MenuBotones titulo="Gastos" descripcion="Catalogos y registro de gastos" icono="fas fa-receipt" color="#f59e0b" secciones={SECCIONES} />
  );
}

export default BotonesGastos;
